
import VueQuickLoadmore from './src/VueQuickLoadmore.vue';

export default {
    install(Vue){
        Vue.component('quick-loadmore', VueQuickLoadmore)
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-quick-loadmore/index.js
// module id = Oij6
// module chunks = 10